/**
 * Tactile feedback for collisions / impacts. iOS Safari does not expose
 * navigator.vibrate (no-op on iPhones); Android browsers buzz the OS
 * vibrator. Always defensive — older browsers and WebViews drop the API
 * silently.
 */

const COLLISION_THRESHOLD_MPS = 6;
const COLLISION_MIN_MS = 20;
const COLLISION_MAX_MS = 90;

export function vibrate(durationMs: number): void {
  const nav = navigator as unknown as { vibrate?: (p: number | number[]) => boolean };
  const fn = nav.vibrate;
  if (typeof fn !== 'function') return;
  try {
    fn.call(navigator, durationMs);
  } catch {
    // Some embedded WebViews throw on calls outside a user gesture.
  }
}

export function vibrateImpact(impactSpeedMps: number): void {
  if (impactSpeedMps < COLLISION_THRESHOLD_MPS) return;
  // Linear ramp from threshold (20ms) to ~30 m/s wall-slam (90ms), capped.
  const t = Math.min(1, (impactSpeedMps - COLLISION_THRESHOLD_MPS) / 24);
  const duration = Math.round(COLLISION_MIN_MS + t * (COLLISION_MAX_MS - COLLISION_MIN_MS));
  vibrate(duration);
}
